import { MeetingsSchedule } from "@api/models/meetings-schedule/MeetingsSchedule";
import { MScheduleSlot } from "@api/models/meetings-schedule/MeetingsScheduleSlot";
import { DateTime, Interval } from "luxon";

export interface MeetingsSlotFabricInterface {
    createSlots(schedule: MeetingsSchedule, exsistingSlots: MScheduleSlot[]): MScheduleSlot[];
}

export class MeetingsSlotFabric implements MeetingsSlotFabricInterface {
    /**
     * Creates slots
     * @param schedule schedule
     * @returns slots
     */
    createSlots(schedule: MeetingsSchedule, exsistingSlots: MScheduleSlot[]) {
        const slots: MScheduleSlot[] = [...exsistingSlots];
        const slotSize = schedule.slotSize || 1;
        const slotCount = Math.floor(Interval.fromDateTimes(schedule.from, schedule.to).toDuration('minutes').minutes / slotSize);
        const existingSlotsBegins = exsistingSlots.map((slot) => (slot.beginAt as DateTime).toISO());

        for (let index = 0; index < slotCount; index++) {

            const begin = schedule.from.plus({ minutes: index * slotSize });
            if (existingSlotsBegins.includes(begin.toISO())) {continue;}

            slots.push(
                new MScheduleSlot({
                    beginAt: begin,
                    endAt: begin.plus({ minutes: slotSize }),
                    scheduleId: schedule.id,
                    isNotAvailable: false,
                })
            )
        }

        return slots.sort((a, b) => {
            if (a.beginAt > b.beginAt) { return 1 }
            if (a.beginAt < b.beginAt) { return -1 }
            return 0;
        });
    }
}